<template>
  <div class="container">
    <div class="content-box">
      <div class="element-wrapper pb-0">
          <h3 class="element-header">
          Dados Credenciado
        </h3>
      </div>
      <transition>
       <div class="element-box">
        <ul id="tabsJustified" class="nav nav-tabs">
            <li class="nav-item"><a href="" data-target="#dadosBasicos" data-toggle="tab" class="nav-link small text-uppercase active">Dados Básicos</a></li>
            <li class="nav-item"><a href="" data-target="#responsavel" data-toggle="tab" class="nav-link small text-uppercase ">Responsável</a></li>
            <li class="nav-item"><a href="" data-target="#endereco" data-toggle="tab" class="nav-link small text-uppercase">Endereço</a></li>
            <li class="nav-item"><a href="" data-target="#acesso" data-toggle="tab" class="nav-link small text-uppercase">Acesso</a></li>
            <li class="nav-item"><a href="" data-target="#image" data-toggle="tab" class="nav-link small text-uppercase">Imagem</a></li>
        </ul>
        <br>
        <div id="tabsJustifiedContent" class="tab-content">
            <div id="dadosBasicos" class="tab-pane fade active show">
                <form id="formDadosBasicos" autocomplete="off" @submit.prevent="salvarDadosBasicos()">
                  <div class="form-row" v-if="isAdministrador">
                    <div class="col form-group">
                      <label for="codigoRede">Código Rede</label>
                      <div class="input-group">
                        <input type="text" class="form-control" v-model="rede.codigoRede">
                        <div class="input-group-append">
                          <button class="btn btn-primary" type="button"
                            @click="updateCodigoRede"
                            title="Atualizar o codigo de rede de todas as Unidades">
                            <i class="fa fa-sync"></i>
                          </button>
                        </div>
                      </div>
                      <small id="emailHelp" class="form-text text-muted">Código utilizado por todas as unidades desta rede</small>
                    </div>
                    <div class="col form-group">
                      <label for="codigoRede">Código Unidade</label>
                      <input type="text" class="form-control" v-model="rede.codigoUnidade">
                      <small id="emailHelp" class="form-text text-muted">Código único da rede</small>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col form-group">
                      <label for="matrizFilial">UNIDADE</label>
                      <input class="form-control" type="text" name="matrizFilial" id="matrizFilial" v-model="matrizFilial" disabled >
                    </div>
                  </div>
                    <div class="form-row">
                        <div v-if="isPJ" class="col form-group">
                            <label for="cnpj">CNPJ</label>
                            <input required type="text" disabled name="cnpj" v-model="rede.cnpj" v-mask="'##.###.###/####-##'" id="cnpj" class="form-control mb-4 mr-sm-2 mb-sm-0" >
                        </div>
                        <div v-else-if="isPF" class="col form-group">
                            <label for="cpf">CPF</label>
                            <input required type="text" disabled name="cpf" v-model="rede.cpf" v-mask="'###.###.###-##'" id="cpf" class="form-control mb-4 mr-sm-2 mb-sm-0" >
                        </div>
                        <div class="col form-group">
                            <label for="tipoUnidade">Tipo de Unidade</label>
                            <input type="text" :value="rede.tipoRede" disabled class="form-control">
                        </div>
                    </div>
                    <div class="form-row" v-if="isPJ">
                        <div class="col form-group">
                            <label for="nome">Nome/Razão Social</label>
                            <input type="text" v-model="rede.razaoSocial"
                              :disabled="!isAdmin" 
                              name="nome" id="nome" class="form-control">
                        </div>
                        <div class="col form-group">
                            <label for="nomeFantasia">Nome Fantasia</label>
                            <input type="text" v-model="rede.nomeRede" 
                              :disabled="!isAdmin"
                              name="nomeFantasia" id="nomeFantasia" class="form-control">
                        </div>
                    </div>
                    <div class="form-row" v-else-if="isPF">
                      <div class="col form-group">
                        <label for="prestador">Prestador</label>
                        <input type="text" v-model="rede.nomeRede" 
                              :disabled="!isAdmin"
                              name="prestador" id="prestador" class="form-control">
                      </div>
                    </div>
                    <div class="form-row">
                        <div class="col form-group">
                            <label for="telefone">Telefone Fixo</label>
                            <input type="tel" v-model="rede.telefoneFixo" 
                              :disabled="!isAdmin"
                              v-mask="['(##) ####-####', '(##) #####-####']" name="telefone" id="telefone" 
                              class="form-control mb-4 mr-sm-2 mb-sm-0" >
                        </div>
                        <div class="col form-group">
                            <label for="celular">Telefone celular</label>
                            <input type="tel" v-model="rede.telefoneCelular" 
                              :disabled="!isAdmin"
                              v-mask="['(##) ####-####', '(##) #####-####']"
                              name="celular" id="celular" class="form-control mb-4 mr-sm-2 mb-sm-0" >   
                        </div>
                        <div class="col form-group">
                            <label for="email">Email de contato da rede</label>
                            <input type="email" v-model="rede.email" 
                              :disabled="!isAdmin"
                              name="email" id="email" class="form-control mb-4 mr-sm-2 mb-sm-0" >   
                        </div>
                    </div>
                    <div class="form-row">
                      <div class="col form-group">
                        <label for="sobre">Descrição Clinica</label>
                        <textarea v-model="rede.sobre" class="form-control" name="sobre" id="sobre" cols="30" rows="10"></textarea>
                      </div>
                    </div>
                    <div class="col text-center">
                       <button type="submit" class="btn btn-primary">Salvar</button>
                    </div>
                </form>
            </div>
            <div id="responsavel" class="tab-pane fade" v-if="rede.responsavel">
              <form id="formResponsavel" autocomplete="off" @submit.prevent="salvarResponsavel()">
                <div class="form-row">
                <div class="col form-group col-md-6">
                    <div class="form-row">
                        <div class="col form-group">
                            <label for="responsavelTecnico">Responsável Técnico</label>
                            <input type="text" v-model="rede.responsavel.nome"
                              :disabled="!isAdmin" 
                              name="responsavelTecnico" id="responsavelTecnico" 
                              class="form-control">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col form-group">
                    <label for="tipoRegistro">Conselho Profissional</label>
                    <select v-model="rede.responsavel.tipoRegistro" 
                        :disabled="!isAdmin"
                        name="tipoRegistro" id="tipoRegistro" class="form-control">
                        <option :value="null">Selecione</option>
                        <option v-for="conselho in listaConselhoProfissional" :value="conselho._id" :key="conselho._id" v-text="conselho.nome"></option>
                    </select>
                </div>
                <div class="col form-group">
                    <label for="nrRegistro">Número</label>
                    <input v-model="rede.responsavel.numeroRegistro" 
                      :disabled="!isAdmin"
                      type="text" name="nrRegistro" id="nrRegistro" class="form-control">
                </div>
                <div class="col form-group col-md-3">
                    <label for="ufRegistro">UF</label>
                    <select v-model="rede.responsavel.ufRegistro" :disabled="!isAdmin"
                      name="ufRegistro" id="ufRegistro" class="form-control">
                        <option :value="null">Selecione</option>
                        <option v-for="uf in ufs" :key="uf.id" :value="uf.id" v-text="uf.id"></option>
                    </select>
                </div>
                    </div>
                </div>
                <div class="col form-group col-md-6">
                    <div class="form-check">
                    <input class="form-check-input" type="checkbox" 
                      value="S" name="agendamentoDrAchei"
                      v-model="rede.agendamento">
                    <label class="form-check-label" for="defaultCheck1">
                        Desejo adquirir o agendamento online pelo DR.Achei
                    </label>
                    </div>
                    <div class="form-check">
                    <input class="form-check-input" type="checkbox"
                     value="S" name="atendimentoDomicilio"
                     v-model="rede.delivery">
                    <label class="form-check-label" for="defaultCheck1">
                        Faço atendimento a domicílio
                    </label>
                    </div>
                </div>
            </div>
            <div class="col text-center">
              <button type="submit" class="btn btn-primary">Salvar</button>
            </div>
            </form>
            </div>

            <div id="endereco" class="tab-pane fade">
                <form id="formEndereco" autocomplete="off" @submit.prevent="salvarEndereco()">
                <div class="form-row">
                    <div class="col form-group col-md-2">
                        <label for="cep">CEP</label>
                        <input @keyup="buscaCEP()" type="tel" 
                          :disabled="!isAdmin" 
                          v-mask="'#####-###'" v-model="rede.cep" 
                          name="cep" id="cep" class="form-control">
                    </div>
                </div>
                <div class="form-row">
                    <div class="col form-group">
                        <label for="logradouro">Logradouro</label>
                        <input type="text" v-model="rede.localAtendimento" 
                          :disabled="!isAdmin"
                          name="logradouro" id="logradouro" class="form-control">
                    </div>
                    <div class="col form-group col-md-2">
                        <label for="numero">Número</label>
                        <input type="text" v-model="rede.numero" 
                          :disabled="!isAdmin"
                          name="numero" id="numero" class="form-control">
                    </div>
                </div>
                <div class="form-row">
                    <div class="col form-group">
                        <label for="bairro">Bairro</label>
                        <input type="text" v-model="rede.bairro" 
                          :disabled="!isAdmin"
                          name="bairro" id="bairro" class="form-control">
                    </div>
                    <div class="col form-group">
                        <label for="cidade">Cidade</label>
                        <input type="text" v-model="rede.cidade" 
                          :disabled="!isAdmin"
                          name="cidade" id="cidade" class="form-control">
                    </div>
                    <div class="col form-group col-md-2">
                        <label for="uf">UF</label>
                        <select name="uf" :disabled="!isAdmin"
                          v-model="rede.uf" id="uf" class="form-control">
                            <option value="">Selecione</option>
                            <option v-for="uf in ufs" :key="uf.id" :value="uf.id" v-text="uf.name"></option>
                        </select>
                    </div>
                    <div class="col form-group">
                        <label for="complemento">Complemento</label>
                        <input type="text" :disabled="!isAdmin"
                          v-model="rede.complemento" name="complemento" id="complemento" class="form-control">
                    </div>
                </div>
                <div class="col text-center">
                  <button type="submit" class="btn btn-primary">Salvar</button>
                </div>
                </form>
            </div>
            <div id="acesso" class="tab-pane fade">
              <form id="formAcesso" autocomplete="off" @submit.prevent="salvarDadosAcesso()">
                <div v-if="acesso && acesso.username">
                  <div class="form-row">
                    <div class="col form-group">
                        <label for="username">Usuário</label>
                        <input type="text" v-model="acesso.username" 
                            disabled
                            name="username" id="username" 
                            class="form-control mb-4 mr-sm-2 mb-sm-0" >
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col col-md-6 form-group">
                      <label for="senhaAtual">Senha Atual</label>
                      <input type="password" v-model="senhaAtual" 
                        name="senhaAtual" id="senhaAtual" 
                        class="form-control mb-4 mr-sm-2 mb-sm-0" >   
                    </div>
                  </div>
                  <div class="row">
                    <div class="col col-md-6 form-group">
                      <label for="novaSenha">Nova Senha</label>
                      <input type="password" v-model="novaSenha"
                        required 
                        name="novaSenha" id="novaSenha" 
                        class="form-control mb-4 mr-sm-2 mb-sm-0" >
                    </div>
                  </div>
                  <div class="row">
                    <div class="col col-md-6 form-group">
                      <label for="repetirSenha">Repetir Nova Senha</label>
                      <input type="password" v-model="repetirNovaSenha" 
                        required
                        name="repetirSenha" id="repetirSenha" 
                        class="form-control mb-4 mr-sm-2 mb-sm-0" >
                    </div>
                  </div>
                </div>
                <div v-else-if="isAdmin">
                  <div class="form-row">
                    <div class="col form-group" :class="{'has-danger': errors.has('username')}">
                        <label for="username">Usuário</label>
                        <input type="text" v-model="username" 
                            name="username" id="username"
                            v-validate="'required'"
                            class="form-control mb-4 mr-sm-2 mb-sm-0" >
                        <div v-if="errors.has('username')" class="help-block form-text text-muted form-control-feedback">
                          {{errors.first('username')}}
                        </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col col-md-6 form-group" :class="{'has-danger': errors.has('novaSenha')}">
                      <label for="novaSenha">Senha</label>
                      <input type="password" v-model="senha"
                        v-validate="'required'" ref="senha"
                        name="novaSenha" id="novaSenha" 
                        class="form-control mb-4 mr-sm-2 mb-sm-0" >
                      <div v-if="errors.has('novaSenha')" class="help-block form-text text-muted form-control-feedback">
                        {{errors.first('username')}}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col col-md-6 form-group" :class="{'has-danger': errors.has('repetirSenha')}">
                      <label for="repetirSenha">Repetir Senha</label>
                      <input type="password" v-model="repetirSenha" 
                        v-validate="'required|confirmed:senha'"
                        name="repetirSenha" id="repetirSenha" 
                        class="form-control mb-4 mr-sm-2 mb-sm-0" >
                      <div v-if="errors.has('repetirSenha')" class="help-block form-text text-muted form-control-feedback">
                        {{errors.first('repetirSenha')}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col text-center">
                  <button type="submit" class="btn btn-primary">Salvar</button>
                </div>
              </form>
            </div>
            <div id="image" class="tab-pane fade">
              <div class="form-desc">
                  Imagens que serão exibidas da sua unidade
              </div>
              <div class="text-right">
                <a href="#" class="btn-primary btn-sm"
                  @click="openModalUpload"
                  title="Adicionar Imagem">
                  <i class="fa fa-plus"></i>
                </a>
              </div>
              <div class="container">
                <div class="row">
                  <div
                    v-if="redeImages.length > 0" 
                    v-for="redeImagem in redeImages" :key="redeImagem._id"
                    class="col-md-3">
                    <div class="card text-center">
                      <img class="card-img-top" :src="redeImagem.image" alt="Card image cap">
                      <div class="card-body">
                        <a href="#" @click="removerImagem(redeImagem)" class="btn btn-primary btn-sn m-2">
                          <i class="fa fa-trash"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div v-if="redeImages.length === 0" class="col-md-12">
                    <p>Não há imagens adicionadas. Clique no Botão <b>+</b> para adicionar imagens</p>
                  </div>
                </div>
              </div>
            </div>
        </div>
       </div>
      </transition>
    </div>
      
    </div>
</template>
<script>
import http from 'axios'
import _ from 'lodash'
import * as userService from '@/store/user/services'
import eventBus from '@/event-bus'

export default {
  async created () {
    eventBus.$on('loadDadosCredenciado.selectRede', (r) => {
      this.$store.dispatch('loadDadosRede', r._id).then((rede) => {
        this.rede = rede
        if (!this.rede.responsavel) {
          this.rede.responsavel = {}
        }
        this.tipoPessoa = rede.cpf ? 'PF' : rede.cnpj ? 'PJ' : ''
        userService.getUserByRedeAndRoleAdmRede(this.idRede)
          .then((response) => {
            this.acesso = response.data[0]
          })
      })
    })
    this.idRede = this.$store.getters.rede._id
    this.$store.dispatch('loadDadosRede', this.idRede).then((rede) => {
      this.rede = rede
      if (!this.rede.responsavel) {
        this.rede.responsavel = {}
      }
      this.tipoPessoa = rede.cpf ? 'PF' : rede.cnpj ? 'PJ' : ''
      userService.getUserByRedeAndRoleAdmRede(this.idRede)
        .then((response) => {
          this.acesso = response.data[0]
        })
    })
    this.$store.dispatch('getUfs').then(ufs => {
      this.ufs = ufs
    })
    this.$store.dispatch('getEspecialidade').then(especialidades => {
      this.especialidades = especialidades
    })
    this.$store.dispatch('getTiposRegistro', '').then(listaConselhoProfissional => {
      this.listaConselhoProfissional = listaConselhoProfissional
    })
    const responseRedeImagem = await http.get(`/redeImagem/${this.idRede}`)
    this.redeImages = responseRedeImagem.data
  },
  computed: {
    isPF () {
      return this.rede && this.rede.cpf
    },
    isPJ () {
      return this.rede && this.rede.cnpj
    },
    matrizFilial () {
      return this.rede.matriz ? 'MATRIZ' : 'FILIAL'
    },
    isAdmin () {
      return this.$store.getters.user.role === 'Administrador' || (this.$store.getters.user.role === 'AdmRede' && this.rede.status === 'PRE_CADASTRO')
    },
    isAdministrador () {
      return this.$store.getters.user.role === 'Administrador'
    }
  },
  data () {
    return {
      username: null,
      senhaAtual: null,
      novaSenha: null,
      repetirNovaSenha: null,
      senha: null,
      repetirSenha: null,
      tipoPessoa: null,
      idRede: null,
      acesso: {
        username: '',
        password: '',
        email: ''
      },
      exibeMsgSucesso: false,
      uf: null,
      ufs: [],
      tiposRede: [],
      tiposUnidade: [],
      termoPrivacidade: null,
      especialidades: [],
      listaConselhoProfissional: [
        'CRM', 'CRF', 'COREN', 'CREFITO', 'CREFONO', 'CRMV', 'CRN', 'CRO', 'CRP', 'CRTR'
      ],
      quantidades: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10
      ],
      redeImages: [],
      rede: {}
    }
  },
  methods: {
    salvarDadosBasicos () {
      this.$store.dispatch('updateRede', this.rede)
    },
    salvarResponsavel () {
      this.$store.dispatch('updateRede', this.rede)
    },
    salvarEndereco () {
      this.$store.dispatch('updateRede', this.rede)
    },
    salvarDadosAcesso () {
      if (this.acesso) {
        delete this.acesso.createdAt
        delete this.acesso.updateAt
        delete this.acesso.__v
      }

      this.$validator.validateAll()
        .then(async result => {
          if (result) {
            if (this.acesso && this.acesso.username) {
              if (this.senhaAtual && this.senhaAtual === this.acesso.password) {
                this.acesso.password = this.novaSenha
                await userService.update(this.acesso)
                this.$store.dispatch('setLoading', false)
                this.$store.dispatch('showSuccessMsg', {body: 'Dados da rede atualizados com Sucesso!'})
              } else {
                this.$toasted.show('A senha atual está incorreta', {
                  icon: { name: 'fa-exclamation-triangle' },
                  type: 'error',
                  theme: 'bubble',
                  action: {
                    text: 'FECHAR',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  }
                })
              }
            } else {
              let newUser = {
                username: this.username,
                name: this.username,
                password: this.senha,
                rede: this.rede,
                role: 'AdmRede'
              }
              await userService.saveAdmRede(newUser)
              this.$store.dispatch('showSuccessMsg', {body: 'Dados da rede atualizados com Sucesso!'})
            }
          }
        })
    },
    onSearchTipoPrestador (search, loading) {
      loading(true)
      this.searchTipoPrestador(loading, search, this)
    },
    searchTipoPrestador: _.debounce((loading, search, vm) => {
      vm.$store.dispatch('getTiposRede', search).then(tiposRede => {
        loading(false)
        vm.tiposRede = tiposRede
      })
    }, 350),
    onSearchTipoUnidade (search, loading) {
      loading(true)
      this.searchTipoUnidade(loading, search, this)
    },
    searchTipoUnidade: _.debounce((loading, search, vm) => {
      vm.$store.dispatch('getTiposRede', search).then(tiposUnidade => {
        loading(false)
        vm.tiposUnidade = tiposUnidade
      })
    }, 350),
    buscaCEP () {
      if (this.rede.cep) {
        this.rede.cep = this.rede.cep.replace(/[-]/g, '')
        if (this.rede.cep.length === 8) {
          http.get(`https://viacep.com.br/ws/${this.rede.cep}/json/`)
            .then((result) => {
              let endereco = result.data
              this.rede.cidade = endereco.localidade
              this.rede.bairro = endereco.bairro
              this.rede.localAtendimento = endereco.logradouro
              this.rede.uf = endereco.uf
              this.rede.complemento = endereco.complemento
            })
        }
      }
    },
    recarregarPagina () {
      window.location.reload()
    },
    async removerImagem (redeImagem) {
      if (confirm('Deseja realmente remover?')) {
        this.$store.dispatch('setLoading', true)
        await http.delete(`/redeImagem/${redeImagem._id}`)
        this.$store.dispatch('setLoading', false)
        const responseRedeImagem = await http.get(`/redeImagem/${this.idRede}`)
        this.redeImages = responseRedeImagem.data
      }
    },
    openModalUpload () {
      eventBus.$emit('openModal', 'modalUploadImageRede')
    },
    async updateCodigoRede () {
      this.$store.dispatch('setLoading', true)
      let nomeRede = this.rede.nomeRede
      let codigoRede = this.rede.codigoRede

      try {
        await http.put('/redes/updateCodigoRede', {nomeRede, codigoRede})
        this.$store.dispatch('setLoading', false)
        this.$store.dispatch('showSuccessMsg', {body: 'Dados da rede atualizados com Sucesso!'})
      } catch (error) {
        console.log(error)
        this.$store.dispatch('setLoading', false)
      }
    }
  }
}
</script>
<style scoped>
.card img {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/DadosCredenciado.vue